import React from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import ToneSettingsPage from "../components/ToneSettingsPage";

const ToneSettings = () => {
  return (
    <Layout>
      <SidebarLayout>
        <ToneSettingsPage/>
      </SidebarLayout>
    </Layout>
  );
};

export default ToneSettings;
